<template>
  <el-date-picker
    v-model="selectedDate"
    type="daterange"
    align="right"
    unlink-panels
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :picker-options="pickerOptions"
    value-format="yyyy-MM-dd"
    ref="datePicker"
  >
  </el-date-picker>
</template>

<script>
export default {
  data() {
    const now = this.$dayjs(new Date());
    return {
      selectedDate: [this.$dateformat(now), this.$dateformat(now)],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick: (picker) => {
              let end = now.subtract(7, "day");
              picker.$emit("pick", [
                this.$dateformat(end),
                this.$dateformat(now),
              ]);
            },
          },
          {
            text: "最近一个月",
            onClick: (picker) => {
              let end = now.subtract(1, "month");
              picker.$emit("pick", [
                this.$dateformat(end),
                this.$dateformat(now),
              ]);
            },
          },
          {
            text: "最近三个月",
            onClick: (picker) => {
              let end = now.subtract(3, "month");
              picker.$emit("pick", [
                this.$dateformat(end),
                this.$dateformat(now),
              ]);
            },
          },
        ],
      },
    };
  },
  computed: {},
  watch: {
    // JSON.stringify(v)
    selectedDate: {
      handler: function (v) {
        this.$emit("input", JSON.stringify(v));
      },
      immediate: true,
    },
  },

  methods: {},
  mounted() {},
};
</script>

<style>
</style>